import { render, staticRenderFns } from "./RedteaSIM.vue?vue&type=template&id=33123987"
import script from "./RedteaSIM.vue?vue&type=script&lang=js"
export * from "./RedteaSIM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports